import { render } from "./BoardCards.vue?vue&type=template&id=01d3ca7e&scoped=true"
import script from "./BoardCards.vue?vue&type=script&lang=js"
export * from "./BoardCards.vue?vue&type=script&lang=js"

import "./BoardCards.vue?vue&type=style&index=0&id=01d3ca7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d3ca7e"]])

export default __exports__